import Tooltip from '@mui/material/Tooltip';

import { sidebarTooltipProps } from './sidebarTooltip';

export type TooltipIconProps = {
  title: string;
  children: React.ReactNode;
  shouldShowTooltip: boolean;
};

export default function TooltipIcon({
  title,
  children,
  shouldShowTooltip,
}: TooltipIconProps) {
  if (shouldShowTooltip) {
    return (
      <Tooltip
        title={title}
        {...sidebarTooltipProps}
        disableHoverListener={!shouldShowTooltip}
        disableFocusListener={!shouldShowTooltip}
        disableTouchListener={!shouldShowTooltip}
      >
        <span>{children}</span>
      </Tooltip>
    );
  }

  return <>{children}</>;
}
